<template>
  <section class="highFrequencyWordPage">
    <popup v-show="isShowHighFrequencyWord" bread="教材管理,课程管理,设置主题资料,编辑高频词" title="编辑高频词" @onBack="popup_back">
      <template slot="button">
        <el-button type="success" @click="saveUploadHighFrequencyWord">保存并上传</el-button>
      </template>
      <infoUpDown :bread="'编辑高频词'">
        <h3 class="group-tit">高频词资料</h3>
        <el-form ref="ref_form" class="upload-form-self" :model="uploadForm" :rules="uploadFormRules" label-width="100px" @submit.native.prevent>
          <el-form-item label="高频词" prop="word">
            <el-input v-model="uploadForm.word" maxlength="20" placeholder="请输入高频词名称" />
          </el-form-item>
          <el-form-item label="高频词读音" prop="wordVoice">
            <themeUploadList code="gpcVoice" :file-list.sync="uploadForm.wordVoice" accept=".mp3" :limit="1" tip="仅支持.mp3文件" />
          </el-form-item>
          <el-form-item label="卡片图" prop="imgFile">
            <themeUploadAvatar code="gpcImg" :file-list.sync="uploadForm.imgFile" />
          </el-form-item>
          <el-form-item label="口型视频" prop="videoList">
            <themeUploadList code="gpcVideo" :file-list.sync="uploadForm.videoList" accept=".mp4" :limit="1" tip="仅支持.mp4文件" />
          </el-form-item>
        </el-form>
        <h3 class="group-tit">关联句型<span>（最多关联10个句型）</span></h3>
        <commonEditSentence
          ref="ref_commonUploadSentence"
          :key="timestamp"
          :max-number="10"
          code="gpc"
          :is-speaking="false"
          :form.sync="uploadForm"
          @formChange="commonUploadSentenceChange"
        />
      </infoUpDown>
    </popup>
  </section>
</template>

<script>
import themeUploadAvatar from '../components/themeUploadAvatar'
import themeUploadList from '../components/themeUploadList'
import commonEditSentence from '../components/commonEditSentence.vue'
import { mapState } from 'vuex'
import { functionData } from '../../../../utils/reg'
import { editHighFrequencyApi } from '../../../../api/teachBookManagement/courseManagement'
export default {
  components: {
    themeUploadAvatar,
    themeUploadList,
    commonEditSentence
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    themeRow: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      isShowHighFrequencyWord: false,
      commonUploadForm: {},
      uploadForm: {
        word: '',
        wordVoice: [],
        imgFile: [],
        videoList: [],
        highFrequencyList: []
      },
      uploadFormRules: {
        word: [{ required: true, message: '请输入高频词名称', trigger: 'blur' }],
        wordVoice: [{ type: 'array', required: true, message: '请上传高频词读音音频', trigger: 'change' }],
        imgFile: [{ type: 'array', required: true, message: '请上传卡片图', trigger: 'change' }],
        videoList: [{ type: 'array', required: true, message: '请上传口型视频', trigger: 'change' }]
      }
    }
  },
  computed: {
    ...mapState('settingThemeData', ['editHighWordList'])
  },
  watch: {
    timestamp: function (val) {
      this.isShowHighFrequencyWord = true
      this.dataChange()
    }
  },
  created () {
  },
  methods: {
    functionIteration(item) {
      const array = { highFrequencyCode: item.highFrequencyCode,
        wordName: item.wordName,
        cardChartName: item.img[0].paramsFileName || item.img[0].fileName,
        cardChartPath: item.img[0].matchPathName || item.img[0].paramsUrl,
        phoneticPronunciationName: item.voice[0].paramsFileName || item.voice[0].fileName,
        phoneticPronunciationPath: item.voice[0].matchPathName || item.voice[0].paramsUrl,
        teachingThemeId: this.themeRow.id,
        meansType: 2,
        id: item.id }
      return array
    },
    dataChange() {
      this.uploadForm.word = this.editHighWordList[0].wordName
      this.uploadForm.id = this.editHighWordList[0].id
      this.uploadForm.highFrequencyCode = this.editHighWordList[0].id
      this.uploadForm.imgFile = functionData(this.editHighWordList[0], 'cardChart', 'CardChart')
      this.uploadForm.videoList = functionData(this.editHighWordList[0], 'mouthShape', 'MouthShape')
      this.uploadForm.wordVoice = functionData(this.editHighWordList[0], 'pronunciation', 'Pronunciation')
      const array = []
      for (const i in this.editHighWordList[0].basicMeansResList) {
        const arrays = {
          id: this.editHighWordList[0].basicMeansResList[i].id,
          highFrequencyCode: this.editHighWordList[0].id,
          wordName: this.editHighWordList[0].basicMeansResList[i].wordName,
          img: functionData(this.editHighWordList[0].basicMeansResList[i], 'cardChart', 'CardChart'),
          voice: functionData(this.editHighWordList[0].basicMeansResList[i], 'pronunciation', 'Pronunciation')
        }
        array.push(arrays)
        this.uploadForm.highFrequencyList = array
      }
      this.uploadForm.yinbiao = this.editHighWordList.phrasesName
    },
    // 返回
    popup_back () {
      this.$refs['ref_form'].resetFields()
      this.isShowHighFrequencyWord = false
      // this.$emit('resetFetchData')
    },
    commonUploadSentenceChange (form) {
      this.commonUploadForm = form
    },
    // 保存并上传操作
    saveUploadHighFrequencyWord () {
      this.$refs['ref_form'].validate((valid) => {
        this.$refs.ref_commonUploadSentence.validateForm()
        if (!valid || !this.$refs.ref_commonUploadSentence.validateForm()) {
          this.$message.error('请正确填写信息')
          return false
        }
        console.log(this.uploadForm)
        const params = {
          // highFrequencyCode: this.uploadForm.word,
          wordName: this.uploadForm.word,
          teachingThemeId: this.editHighWordList[0].teachingThemeId,
          cardChartName: this.uploadForm.imgFile[0].paramsFileName || this.uploadForm.imgFile[0].fileName,
          cardChartPath: this.uploadForm.imgFile[0].matchPathName || this.uploadForm.imgFile[0].paramsUrl,
          mouthShapeName: this.uploadForm.videoList[0].paramsFileName || this.uploadForm.videoList[0].fileName,
          mouthShapePath: this.uploadForm.videoList[0].matchPathName || this.uploadForm.videoList[0].paramsUrl,
          meansType: 1,
          phoneticPronunciationName: this.uploadForm.wordVoice[0].paramsFileName || this.uploadForm.wordVoice[0].fileName,
          phoneticPronunciationPath: this.uploadForm.wordVoice[0].matchPathName || this.uploadForm.wordVoice[0].paramsUrl,
          highFrequencyList: [],
          id: this.uploadForm.id
        }
        for (const item of this.uploadForm.highFrequencyList) {
          params.highFrequencyList.push(this.functionIteration(item))
        }
        console.log(params)
        try {
          editHighFrequencyApi(params).then(res => {
            this.$message.success('修改成功')
            this.popup_back()
            this.$emit('resetFetchData')
          })
        } catch (e) {
          this.$message.closeAll()
          this.$message.error(e)
        }
      })
    }

  }
}
</script>

<style lang='scss'>
.highFrequencyWordPage{
  .group-tit{
    margin: 24px 0;color:#53402B;display: flex;
    align-items: center;
    span{color: #898884;}
    &::before{
      content: '';
      width: 6px;
      height: 22px;
      display: inline-block;
      background: #FCDA6F;
      margin-right: 8px;
      border-radius: 9px;
    }
  }
}
.upload-form-self{
  display: flex;
  flex-wrap: wrap;
  .el-form-item{
    /*display: inline-block;*/
    width: 40%;
    &:nth-child(odd){
      margin-right: 10%;
    }
  }
}
</style>
